import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

// Bind functions to buttons
function ex_fitorigin(value: string) {
  var a = value.split(" ").map((x: string) => parseFloat(x));
  const highlightElement = document.getElementById(
    "highlight"
  ) as HTMLInputElement;
  if (highlightElement !== null && highlightElement.checked == true) {
    LwAPI?.highlightByOrigin(a[0], a[1], a[2]);
  }
  const fitElement = document.getElementById("fit") as HTMLInputElement;
  if (fitElement !== null && fitElement.checked == true) {
    LwAPI?.fitInByOrigin(a[0], a[1], a[2]);
  }
}

const selectElement = document.getElementById("pmi_to") as HTMLSelectElement;
selectElement?.addEventListener("change", async () => {
  await apiReady;
  const selectedText = selectElement.options[selectElement.selectedIndex].text;
  ex_fitorigin(selectedText);
});
